/**
 * Tier configuration - maps backend tier names to display names
 *
 * Backend/DB uses: "FREE", "TIER 1", "TIER 2", "TIER 3"
 * Frontend displays: "FREE", "STUDENT", "PRO", "TIER 3"
 */

export const TIER_DISPLAY_NAMES = {
    'FREE': 'FREE',
    'TIER 1': 'STUDENT',
    'TIER 2': 'PRO',
    'TIER 3': 'TIER 3',
    'ADMIN': 'ADMIN'
};

/**
 * Get the display name for a tier
 * @param {string} tier - Backend tier name (e.g., "TIER 1")
 * @returns {string} Display name (e.g., "STUDENT")
 */
export function getTierDisplayName(tier) {
    return TIER_DISPLAY_NAMES[tier] || tier;
}
